<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Configuration des PDA</h1>
            <i class="fas fa-qrcode fa-2x" @click="openModal()"/>
        </div>

        <div class="row mb-2">
            <div class="filter-bar ui basic segment grid ml-auto ">
                <div class="ui form row divResearch">
                    <input type="text" v-model="filterText" @keyup.enter="doFilter" placeholder="Rechercher..."
                           class="marginResearch">
                    <button class="btn btn-custom marginResearch" @click="doFilter">Rechercher</button>
                    <button class="btn btn-light" id="mlButtonAnnuler" @click="resetFilter">Annuler</button>

                </div>
            </div>
        </div>
        <div class="mb-3 background-alt">
            <div class="table-responsive">
                <vuetable ref="vuetable"
                          api-url="/api/devices"
                          :fields="fields"
                          pagination-path=""
                          :append-params="moreParams"
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          @vuetable:pagination-data="onPaginationData"
                          class="table device-table"
                          no-data-template=""
                >

                    <div slot="gender-slot" slot-scope="props">
                        <input type="checkbox" v-model="props.rowData.is_debug" @click="updateDebug(props.rowData.id)">
                    </div>

                    <div slot="mobile_app_auto_update" slot-scope="props">
                        <input type="checkbox" v-model="props.rowData.mobile_app_auto_update" @click="updateAppAutoUpdate(props.rowData.id)">
                    </div>

                    <div slot="gender-slot1" slot-scope="props">
                        <button class="btn-custom btn" @click="dlLogs(props.rowData.imei)"
                                title="Télécharger les logs"><i class="fas fa-download"/></button>
                        <button class="btn-danger btn" @click="deleteLogs(props.rowData.imei)"
                                title="Supprimer les logs"><i class="fas fa-trash-alt"/></button>
                    </div>
                </vuetable>
            </div>

            <div class="row col-lg-12 pr-0">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} PDA"
                                              no-data-template="Aucun PDA"
                    />
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"
                    />
                </div>
            </div>

            <modal :showModal="showModal" :hideModal="hideModal" :openModal="openModal">
                <h5 slot="header">
                    QrCode
                </h5>

                <span slot="body" class="w-100">
                    <div class="w-100 divQrCode">
                        <vue-qr-code :value="qrCode" :options="{ width: 350 }"/>
                    </div>
                </span>

                <span slot="footer">
                    <button class="btn btn-danger" title="Réinitialiser la rechercher"
                            @click="hideModal">Fermer </button>
                </span>
            </modal>
        </div>

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import Vuetable from 'vuetable-2';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import Swal from 'sweetalert2';
    import Vue from 'vue';
    import axios from 'axios';
    import VueQrCode from '@chenfengyuan/vue-qrcode';
    import Modal from './layout/Modal';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";

    export default {
        components: {Vuetable, VuetablePagination, VuetablePaginationInfo, VueQrCode, Modal, InfringementSearchResultModal},
        computed: {
            api_token() {
                return api_token;
            }
        },
        data() {
            return {
                debug: '',
                filterText: '',
                qrCode: 'default',
                showModal: false,
                moreParams: {},

                fields: [
                    {
                        name: 'single_key',
                        title: 'N° unique',
                    },
                    {
                        name: 'model_pda',
                        title: 'Modèle'
                    },
                    {
                        name: 'manufacturer_pda',
                        title: 'Marque'
                    },
                    {
                        name: 'imei',
                        title: 'N° imei'
                    },
                    {
                        name: 'operating_system',
                        title: 'OS'
                    },
                    {
                        name: 'mobile_app_version',
                        title: 'Version de<br/>l\'application'
                    },
                    {
                        name: 'file_quantity',
                        title: 'Nombre<br/>de fichier'
                    },
                    {
                        name: 'last_update',
                        title: 'Dernière synchro',
                    },
                    {
                        name: 'gender-slot',
                        title: 'Debug',
                    },
                    {
                        name: 'mobile_app_auto_update',
                        title: 'Mise à jour<br/>automatique',
                    },
                    {
                        name: 'gender-slot1',
                        title: '',
                    }
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                },
            }
        },
        beforeCreate() {

        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            dlLogs(imei) {
                axios.get('/download/log?imei=' + imei,
                    {
                        responseType: 'blob'
                    })
                    .then((response) => {
                        if (response.data.size <= 10) {
                            Swal(
                                'Aucun fichier de log disponible.'
                            );
                        } else {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'logs.zip'); //or any other extension
                            document.body.appendChild(link);
                            link.click();
                        }
                    });
            },

            deleteLogs(imei) {
                Swal({
                    title: 'Êtes vous sur ?',
                    text: "Les fichiers seront perdus.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Supprimer'
                }).then((result) => {
                    if (result.value) {
                        axios.delete('/api/devices/' + imei)
                            .then(result => {
                                Swal(
                                    'Supprimé !',
                                    'Fichier(s) supprimé(s).',
                                    'success'
                                );
                            });
                    }
                });
                this.$refs.vuetable.reload();
            },

            updateDebug(id) {
                axios.put('/api/devices/' + id, {
                    type: 'debug',
                })
                    .then(result => {
                        Swal(
                            'Mis à jour !',
                            'Debug modifié.',
                            'success'
                        );
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            updateAppAutoUpdate(id) {
                axios.put('/api/devices/' + id, {
                    type: 'mobile_app_auto_update',
                })
                        .then(result => {
                            Swal(
                                    'Mis à jour !',
                                    'Mise à jour automatique modifié.',
                                    'success'
                            );
                        })
                        .catch(error => {
                            console.log(error.message)
                        });
            },

            doFilter() {
                this.moreParams = {
                    'filter': this.filterText
                };
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },

            resetFilter() {
                this.moreParams = {};
                this.filterText = '';
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },

            openModal() {
                axios.get('/api/qrCode')
                    .then(result => {
                        this.qrCode = result.data;
                        this.showModal = true;
                    })
                    .catch(error => {
                        console.log(error.message);
                    });
            },

            hideModal() {
                this.showModal = false;
            },
        },
    }
</script>

<style scoped>

    #mlButtonAnnuler {
        margin-right: 20px;
    }

    .marginResearch {
        margin-right: 10px;
    }

    .divResearch {
        margin-right: -5px;
    }

    .fa-qrcode {
        cursor: pointer;
    }

    .divQrCode {
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>

<style>
    .device-table td,
    .device-table thead th{
        vertical-align: middle !important;
        text-align: center !important;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Device.vue